// ./src/components/generic/LoadingDataBlock/LoadingDataBlock.tsx
import React from "react";
import { Paper, Stack, Center, Text } from "@mantine/core";

import { LoadingIndicator } from "../LoadingIndicator";

export interface LoadingDataBlockProps {
  text?: string;

  /** Additional className for styling */
  className?: string;

  withBorder?: boolean;

  /** Additional styles */
  style?: React.CSSProperties;
}

export const LoadingDataBlock: React.FC<LoadingDataBlockProps> = ({
  text,
  withBorder = true,
  className,
  style,
}) => {
  return (
    <Paper withBorder={withBorder} className={className || ""} style={style}>
      <Center p="xl">
        <Stack align="center" gap="md">
          <LoadingIndicator size="lg" />
          <Text c="dimmed">{text || "Loading data..."}</Text>
        </Stack>
      </Center>
    </Paper>
  );
};
